import React, { useEffect, useState, useContext } from 'react';
import styles from './ExpiredProductsManagement.module.css';
import ArrowBelow from '../../assets/arrow_below.svg';

import { getExpiredProductsByStoreId } from "../../hooks/ExpiredProduct";
import { getStoresFromDatabase } from "../../hooks/Store";
import { filterExpiredProductsByStore } from "../../hooks/ExpiredProduct";

import { ExpiredProductContext } from '../../context/ExpiredProductContext';
import { FilterExpiredProductContext } from '../../context/FilterExpiredProductContext';
import { StoresContext } from '../../context/StoresContext';
import { UserContext } from '../../context/UserContext';
import { useModal } from '../../context/ModalContext';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import { GetStatusColor } from "../../utils/GetStatusColor";
import { TransformDateToBrazilianFormat } from "../../utils/TransformDateToBrazilianFormat";

const ExpiredProductsManagement = () => {

    const { 
        isMoreInformation, 
        clearMoreInformation, 
        isEditedExpiredProduct,
        clearExpiredProduct,
        isDeletedExpiredProduct,
        setExpiredProduct,
        setExpiredProductIds,
        isTransferred,
        setExpiredFilteredProducts
     } = useContext(ExpiredProductContext);

     const { 
        setUserIds
     } = useContext(UserContext);

    const {
        setUserNameSelectedSelected,
        setIsProductNameSelected, 
        setIsManufacturerSelected,
        setIsLotSelected,
        setIsExpirationDateSelected,
        setIsDaysToExpireSelected,
        setIsGroupSelected,
        setIsStatusProductSelected,
        setIsLostProductSelected,
        setIsBarCodeSelected,
        setIsProductQuantitySelected,
        setIsProductSoldSelected,
        setIsProductBalanceSelected,
        setIsProductLocationSelected,
        clearFilterState,
        filterData,
        setFilterData,
        setStoreId,
        isFilter,
        setIsFilter
    } = useContext(FilterExpiredProductContext);


    const handleOpenFilter = ( setFilterContext ) => {
        setIsProductNameSelected(false);
        setIsManufacturerSelected(false);
        setIsLotSelected(false);
        setIsExpirationDateSelected(false);
        setIsDaysToExpireSelected(false);
        setIsGroupSelected(false);
        setIsStatusProductSelected(false);
        setIsLostProductSelected(false)
        setIsBarCodeSelected(false)
        setIsProductQuantitySelected(false)
        setIsProductSoldSelected(false)
        setIsProductBalanceSelected(false)
        setIsProductLocationSelected(false)
        setFilterContext(true);
        openFilterModal();
    };

    const { setStore } = useContext(StoresContext);
    const [expiredProducts, setExpiredProducts] = useState([]);
    const [stores, setStores] = useState([]);
    const [selectedStoreId, setSelectedStoredId] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage] = useState(50);
    const [totalItems, setTotalItems] = useState(0);
    const [selectedExpiredProducts, setSelectedExpiredProducts] = useState([]);
    const [selectAll, setSelectAll] = useState(false);


    const filterLabels = {
        userIds: "Colaborador",
        barcode: "Código de Barras",
        name: "Nome do Produto",
        manufacturer: "Fabricante",
        lot: "Lote",
        expirationDate: "Data de Validade",
        daysToExpire: "Dias para Expirar",
        group: "Grupo",
        quantity: "Quantidade",
        quantityLost: "Quantidade Perdida",
        quantitySold: "Quantidade Vendida",
        balance: "Saldo",
        statusColors: "Status",
        location: "Localização"
    };
    
    
    const activeFilters = Object.entries(filterData)
    .filter(([key, value]) => {
        if (key === "storeId") return false;
        
        if (value === null || value === undefined || value === "") return false;
        
        if (Array.isArray(value) && value.length === 0) return false;
        
        // Verifica se é um objeto (mas não array) e se tem pelo menos um valor não vazio
        if (typeof value === 'object' && !Array.isArray(value)) {
            return Object.values(value).some(val => val !== null && val !== undefined && val !== "");
        }
        
        return true;
    })
    .map(([key, value]) => ({
        label: filterLabels[key] || key,
        key
    }));
    

    const handleRemoveFilter = (key) => {
        const newFilterData = { ...filterData };
        delete newFilterData[key];
        setFilterData(newFilterData); 
    }
    

    useEffect(() => {
        setExpiredFilteredProducts([])
        setExpiredProducts([])
        setFilterData({});
        setIsFilter(false);
        fetchStores();
        clearFilterState()
        clearMoreInformation();
        setStore(null)
    },[]);

    
    useEffect(() => {  
        if(filterData.storeId != null || filterData.storeId !== undefined) {
            (async () => {
                const response = await filterExpiredProductsByStore(filterData, currentPage, itemsPerPage);
                if(response) {
                    setExpiredProducts(response ? response.data.data : []);
                    setExpiredFilteredProducts(response ? response.data.data : [])
                    setTotalItems(response.data.totalItems || 0);
                }else {
                    setExpiredFilteredProducts([])
                    setExpiredProducts([]);
                }
            })();
        }
        
    }, [currentPage, filterData])


    useEffect(() => {
        if(!isFilter) {
            if(selectedStoreId != null || selectedStoreId !== undefined) {
                fetchExpiredProductsByStoreId(selectedStoreId, currentPage, itemsPerPage);
            }
        }
    }, [currentPage, selectedStoreId]);


    // Edit product
    useEffect(() => {
        if (isEditedExpiredProduct !== null) {
            if (isEditedExpiredProduct) {
                toast.success("Produto editado com sucesso.");
    
                if (selectedStoreId) {
                    fetchExpiredProductsByStoreId(selectedStoreId, currentPage, itemsPerPage);
                }
            }
            clearExpiredProduct();
        }
    }, [isEditedExpiredProduct, clearExpiredProduct]);


     // Delete product
    useEffect(() => {
        if (isDeletedExpiredProduct !== null) {
            if (isDeletedExpiredProduct) {
                toast.success("Produto(s) validado(s) deletado(s) com sucesso.");
                if (selectedStoreId) {
                    fetchExpiredProductsByStoreId(selectedStoreId, currentPage, itemsPerPage);
                }
            }
            clearExpiredProduct();
        }
    }, [isDeletedExpiredProduct, clearExpiredProduct]);


    useEffect(() => {
        if (isTransferred !== null) {
            if (isTransferred) {
                toast.success("Produto(s) transferidos(s) com sucesso.");
                if (selectedStoreId) {
                    fetchExpiredProductsByStoreId(selectedStoreId, currentPage, itemsPerPage);
                }
            }

            clearExpiredProduct();
        }

    }, [isTransferred, clearExpiredProduct]);


    const fetchStores = async () => {
        try {
            const storeData = await getStoresFromDatabase();
            if (storeData) {
                setStores(storeData.data.stores);
            }
        }catch(err) {
            console.error("Error to search stores:", err);
        }
    };


    const fetchExpiredProductsByStoreId = async (storeId, page, limit) => {
        try {
            const expiredProductData = await getExpiredProductsByStoreId(storeId, page, limit);
            if (expiredProductData) {
                setExpiredProducts(expiredProductData.data.data);
                setExpiredFilteredProducts(expiredProductData.data.data);
                setTotalItems(expiredProductData.data.totalItems || 0);
            } else {
                setExpiredFilteredProducts([])
                setExpiredProducts([]);
            }
        } catch (error) {
            console.error("Erro ao buscar produtos:", error);
            setExpiredFilteredProducts([])
            setExpiredProducts([]);
        }
    };


    const handleStoreChange = (event) => {
        const storeId = event.target.value;
        setSelectedStoredId(storeId);
        setStoreId(storeId);

        const selectedStore = stores.find(store => store.id === Number(storeId));
        setStore(selectedStore); 
    };


    const handleCheckboxChange = ( expiredProductId ) => {
        setSelectedExpiredProducts((prevSelected) => {
            const updatedSelected = prevSelected.includes(expiredProductId)
                ? prevSelected.filter((id) => id !== expiredProductId)
                : [...prevSelected, expiredProductId];
            setExpiredProduct(expiredProducts.filter((expiredProduct) => updatedSelected.includes(expiredProduct.id)));
            setExpiredProductIds(updatedSelected);
            return updatedSelected;
        });
    };


    const handleSelectAll = () => {
        const updatedSelected = selectAll ? [] : expiredProducts.map((exiredProduct) => exiredProduct.id);
        setExpiredProduct(expiredProducts.filter((exiredProduct) => updatedSelected.includes(exiredProduct.id)));
        setSelectedExpiredProducts(updatedSelected);
        setExpiredProductIds(updatedSelected);
        setSelectAll(!selectAll);
    };

    useEffect(() => {
        if (selectedExpiredProducts?.length > 0) {
       
          const selectedProductsFullData = expiredProducts.filter(exp => 
            selectedExpiredProducts.includes(exp.id))
          
     
          const uniqueUserIds = [...new Set(
            selectedProductsFullData.map(product => product.user?.id).filter(Boolean)
          )];
          
          setUserIds(uniqueUserIds);
        } else {
          setUserIds([]);
        }
      }, [selectedExpiredProducts, expiredProducts]);


    const handlePreviousPage = () => { setCurrentPage((prev) => Math.max(prev - 1, 1)) };
    const handleNextPage = () => { setCurrentPage((prev) => Math.min(prev + 1, Math.ceil(totalItems / itemsPerPage))) };
    const { openFilterModal } = useModal();


    const loadExpiredProductHeader = () => {

        return (
            <tr>
                 {(expiredProducts?.length > 0) ? (
                    <th>
                        <div className={styles.scrollableHeader}>
                            <input
                                type="checkbox"
                                checked={ selectAll }
                                onChange={ handleSelectAll }/>
                        </div>
                    </th>
                ) : <th></th>}

                <th><div className={styles.scrollableHeader}>N° Linha</div></th>
                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Colaborador
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setUserNameSelectedSelected)}
                            />
                        </div>
                        
                    </div>
                </th>

                { isMoreInformation ? 
                
                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Código Barras
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setIsBarCodeSelected)}
                            />
                        </div>
                    </div>
                </th>   
                :
                null 
            }
                
                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Nome
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setIsProductNameSelected)}
                            />
                        </div>
                    </div>
                </th>   
                
                { isMoreInformation ? 
                
                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Fabricante
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setIsManufacturerSelected)}
                            />
                        </div>
                    </div>
                </th>   
                :
                null 
            }
                
        { isMoreInformation ? 
        <th>
            <div className={styles.scrollableHeader}>
                <div className={styles.scrollableRow}>
                    Grupo
                    <img
                        src={ArrowBelow}
                        alt="Filter Worker"
                        className={styles.filterIcon}
                        onClick={() => handleOpenFilter(setIsGroupSelected)}
                        />
                </div>
            </div>
        </th>   
        : null 
        
        }

         <th>
            <div className={styles.scrollableHeader}>
                <div className={styles.scrollableRow}>
                    Lote
                    <img
                        src={ArrowBelow}
                        alt="Filter Worker"
                        className={styles.filterIcon}
                        onClick={() => handleOpenFilter(setIsLotSelected)}
                        />
                </div>
            </div>
        </th>   
            <th>
                <div className={styles.scrollableHeader}>
                    <div className={styles.scrollableRow}>
                        Data de validade
                        <img
                        src={ArrowBelow}
                        alt="Filter Worker"
                        className={styles.filterIcon}
                        onClick={() => handleOpenFilter(setIsExpirationDateSelected)}
                        />
                    </div>
                </div>
            </th>

                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Dias a vencer
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setIsDaysToExpireSelected)}
                            />
                        </div>
                        
                    </div>
                </th>

                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Status produto
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setIsStatusProductSelected)}
                            />
                        </div>
                        
                    </div>
                </th>
                
                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Quantidade
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setIsProductQuantitySelected)}
                            />
                        </div>
                        
                    </div>
                </th>

                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Vendido
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setIsProductSoldSelected)}
                            />
                        </div>
                        
                    </div>
                </th>

                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Perdido
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setIsLostProductSelected)}
                            />
                        </div>
                        
                    </div>
                </th>

                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Saldo
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setIsProductBalanceSelected)}
                            />
                        </div>
                        
                    </div>
                </th>
                
                { isMoreInformation ? 
                
                <th>
                    <div className={styles.scrollableHeader}>
                        <div className={styles.scrollableRow}>
                            Localização
                            <img
                            src={ArrowBelow}
                            alt="Filter Worker"
                            className={styles.filterIcon}
                            onClick={() => handleOpenFilter(setIsProductLocationSelected)}
                            />
                        </div>
                    </div>
                </th>   
                :
                null 
            }
            
            
            </tr>
        );
    };

    const loadExpiredProductRow = () => {
        return (
            <>
                { expiredProducts.map((expiredProduct, index) => (
                    <tr key={expiredProduct.id}>
                          <td>
                            <input
                                type="checkbox"
                                checked={selectedExpiredProducts.includes(expiredProduct.id)}
                                onChange={() => handleCheckboxChange(expiredProduct.id)}
                            />
                        </td>

                        <td>{index + 1 + (currentPage - 1) * itemsPerPage}</td>
                        <td>{expiredProduct?.user?.name}</td>
                        { isMoreInformation ? <td>{expiredProduct.product.barcode}</td> : null}  
                        <td>{expiredProduct.product.name}</td>
                        { isMoreInformation ? <td>{expiredProduct.product.manufacturer}</td> : null}
                        { isMoreInformation ? <td>{expiredProduct.product.group}</td> : null}  
                        <td>{expiredProduct.lot}</td>
                        <td>{TransformDateToBrazilianFormat(expiredProduct.expirationDate)}</td>
                        <td>{expiredProduct.daysToExpire}</td>
                        <td style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                            <span
                                style={{
                                    width: '18px',
                                    height: '18px',
                                    borderRadius: '50%',
                                    backgroundColor: 
                                    expiredProduct.statusColor === 'green'
                                        ? '#00FF00'
                                        : expiredProduct.statusColor === 'yellow'
                                        ? '#FFFF00'
                                        : expiredProduct.statusColor === 'red'
                                        ? '#FF0000'
                                        : 'transparent',
                                }}
                            ></span>
                            
                            {GetStatusColor(expiredProduct.statusColor, expiredProduct.daysToExpire)}
                        </td>
                        <td>{expiredProduct.quantity}</td>
                        <td>{expiredProduct.quantitySold}</td>
                        <td>{expiredProduct.quantityLost}</td>
                        <td>{expiredProduct.balance}</td>
                        { isMoreInformation ? <td>{expiredProduct.location}</td> : null }
                        
                    </tr>
                ))}
            </>
        );
    };

   

    return (
        <div className={styles.container}>
            <ToastContainer />

            { activeFilters.length > 0 && (
            <div className={styles.filtersContainer}>
                {activeFilters.map(filter => (
                    <div key={filter.key} className={styles.filterTag} onClick={() => handleRemoveFilter(filter.key)}>
                        {filter.label} <span className={styles.closeButton}>✖</span>
                    </div>
                ))}
            </div>
        )}

            <div className={styles.infoLine}>
                
                <div className={styles.infoLineHead}>
                    <img src={ArrowBelow} alt="Seta para baixo" />
                    <h4 className={styles.headerInfo}>Tabela de Produtos</h4>
                </div>  

                <div className={styles.infoLineSelected}>
                    <select className={styles.storeDropdown} onChange={ handleStoreChange }>
                        <option value="" disabled selected>Selecione uma loja</option>
                        {stores.map((store) => (
                            <option key={store.id} value={store.id}>{store.name}</option>
                        ))}
                    </select>

                    <div className={styles.pagination}>
                        <button onClick={ handlePreviousPage } disabled={currentPage === 1}>
                            {"<"}
                        </button>
                        <span>
                            {(currentPage - 1) * itemsPerPage + 1}-{Math.min(currentPage * itemsPerPage, totalItems)} de {totalItems}
                        </span>
                        <button onClick={ handleNextPage } disabled={currentPage === Math.ceil(totalItems / itemsPerPage)}>
                            {">"}
                        </button>
                    </div>
                </div>

            </div>

            
            <div className={styles.tableItems}>
            <table>
                <thead>
                    { loadExpiredProductHeader() }  
                </thead>
                <tbody>
                { loadExpiredProductRow() }

                </tbody>
            </table>
        </div>
    </div>
    );
};

export default ExpiredProductsManagement;